<template>
  <div class="kk-design__colors">
    <div
      v-for="(color, index) in colors"
      :key="index"
      class="kk-design__colors_wrapper"
      :class="{ 'kk-design__colors_active': activeIndex === index }"
      :data-test-id="`icon-item-${color?.split('mdi-').pop()}`"
    >
      <color :color="color" @select-color="selectColor" />
    </div>
  </div>
</template>

<script>
import { HotkeyScopes } from "../../../../utils/constants";
import Color from "./Color.vue";
import hotkeys from "hotkeys-js";
export default {
  components: {
    Color,
  },
  props: ["colors"],
  emits: ["select-color", "hide"],
  data() {
    return {
      activeIndex: 0,
    };
  },
  mounted() {
    this.$store.dispatch("setScope", HotkeyScopes.Colors);
    hotkeys("left, right, up, down, escape, enter", HotkeyScopes.Colors, (event, handler) => {
      event.preventDefault();
      switch (handler.key) {
        case "left":
          this.moveLeft();
          break;
        case "right":
          this.moveRight();
          break;
        case "up":
          this.moveUp();
          break;
        case "down":
          this.moveDown();
          break;
        case "escape":
          this.$emit("hide");
          break;
        case "enter":
          this.selectColor(this.colors[this.activeIndex], true);
          break;
      }
    });
  },
  beforeUnmount() {
    hotkeys.unbind("left, right, up, down, escape, enter", HotkeyScopes.Colors);
    this.$store.dispatch("setScope", HotkeyScopes.EditToolBox);
  },
  methods: {
    selectColor(color, showTooltip) {
      this.$emit("select-color", color, showTooltip);
    },
    moveRight() {
      if (this.activeIndex < this.colors.length - 1) this.activeIndex += 1;
    },
    moveLeft() {
      if (this.activeIndex > 0) this.activeIndex -= 1;
    },
    moveUp() {
      if (this.activeIndex === -1) this.activeIndex = this.colors.length - 1;
      else if (this.activeIndex >= 4) this.activeIndex -= 4;
    },
    moveDown() {
      if (this.activeIndex === -1) this.activeIndex += 1;
      else if (this.activeIndex < 12) this.activeIndex += 4;
    },
  },
};
</script>
<style lang="less" scoped>
@import "../../../../assets/styles/variables.less";

.kk-design {
  &__colors {
    gap: 0.2rem;
    max-height: 20rem;
    overflow: auto;
    padding: 0.5rem;
    position: absolute;
    transform: translate(0%, 65%);
    border-radius: 8px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    border: 0.5px solid lightgray;
    background-color: @kk-color-background;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: 10px; /* Optional: Add space between grid items */
    &_wrapper {
      border-radius: 50%;
      border: 1px solid white;
    }
    &_active {
      border: 1px solid black;
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    }
  }
}
</style>
